<template>
  <div class="responsive-layout">
    <!-- 移动端顶部栏 -->
    <header class="mobile-header" v-if="isMobile">
      <div class="mobile-header-content">
        <div class="logo">
          <h1>成都劲峰物流有限公司</h1>
        </div>
        <button 
          class="menu-toggle" 
          @click="toggleMobileMenu"
          :class="{ active: isMenuOpen }"
          aria-label="切换菜单"
        >
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
        </button>
      </div>
    </header>

    <!-- 桌面端导航栏 -->
    <nav class="desktop-nav" v-else>
      <div class="nav-container">
        <div class="nav-header">
          <div class="logo-container">
            <img src="/jfLogo.png" alt="劲峰物流 Logo" class="company-logo">
          </div>
          <div class="company-name">成都劲峰物流有限公司</div>
        </div>
        <ul class="nav-links">
          <li v-for="item in navItems" :key="item.name">
            <router-link 
              :to="item.path" 
              class="nav-link"
              :class="{ active: $route.path === item.path }"
              @click="handleDesktopNavClick"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <!-- 移动端侧边菜单 -->
    <aside 
      class="mobile-menu" 
      :class="{ open: isMenuOpen }"
      v-if="isMobile"
    >
      <div class="mobile-menu-overlay" @click="closeMobileMenu"></div>
      <div class="mobile-menu-content">
        <ul class="mobile-nav-links">
          <li v-for="item in navItems" :key="item.name">
            <router-link 
              :to="item.path" 
              class="mobile-nav-link"
              :class="{ active: $route.path === item.path }"
              @click.stop="handleNavClick(item.path)"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </aside>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 页脚 -->
    <footer class="site-footer">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>成都劲峰物流有限公司</h3>
            <p>专业的物流服务提供商</p>
          </div>

          <div class="footer-section">
            <h4>联系方式</h4>
            <p>
              <a href="tel:02885589998" class="contact-link phone-link" title="拨打：028-85589998">
                📞 028-85589998
              </a>
            </p>
            <p>
              <a href="mailto:285428156@qq.com" class="contact-link email-link" title="发送邮件：285428156@qq.com">
                ✉️ 285428156@qq.com
              </a>
            </p>
          </div>
          <div class="footer-section">
            <h4>服务热线</h4>
            <p>
              <a href="tel:18200156562" class="contact-link phone-link" title="拨打：18200156562">
                📱 18200156562
              </a>
            </p>
            <p>
              <a href="tel:13980576928" class="contact-link phone-link" title="拨打：13980576928">
                📱 13980576928
              </a>
            </p>
            <p>
              <a href="tel:13908186966" class="contact-link phone-link" title="拨打：13908186966">
                📱 13908186966
              </a>
            </p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2026 成都劲峰物流有限公司. 保留所有权利.</p>
          <p class="icp-info">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" class="icp-link">
              蜀ICP备17003680号
            </a>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const isMenuOpen = ref(false)
const windowWidth = ref(window.innerWidth)

const navItems = [
  { name: '首页', path: '/' },
  { name: '公司简介', path: '/about' },
  { name: '专线展示', path: '/products' },
  { name: '联系我们', path: '/contact' }
]

const isMobile = computed(() => windowWidth.value <= 768)

const toggleMobileMenu = () => {
  console.log('切换移动端菜单:', !isMenuOpen.value)
  isMenuOpen.value = !isMenuOpen.value
  document.body.style.overflow = isMenuOpen.value ? 'hidden' : ''
}

const closeMobileMenu = () => {
  console.log('关闭移动端菜单')
  isMenuOpen.value = false
  document.body.style.overflow = ''
}

// 移动端导航链接点击处理
const handleNavClick = (path) => {
  console.log('=== 导航点击事件触发 ===')
  console.log('点击路径:', path)
  console.log('当前路由:', route.path)
  console.log('目标路由:', path)
  
  // 阻止事件冒泡
  event.stopPropagation()
  
  // 关闭菜单
  closeMobileMenu()
  
  console.log('菜单关闭完成')
}

const handleDesktopNavClick = () => {
  console.log('桌面端导航点击')
  // 桌面端不需要关闭菜单
}

const handleResize = () => {
  windowWidth.value = window.innerWidth
  if (windowWidth.value > 768) {
    closeMobileMenu()
  }
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  document.body.style.overflow = ''
})
</script>

<style scoped>
.responsive-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* 移动端头部 */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.mobile-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}

.logo h1 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  display: block;
  text-align: center;
  color: white;
  white-space: nowrap;
}

.menu-toggle {
  display: flex;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 1001;
}

.hamburger-line {
  width: 25px;
  height: 3px;
  background-color: white;
  margin: 3px 0;
  transition: 0.3s;
  border-radius: 2px;
}

.menu-toggle.active .hamburger-line:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.menu-toggle.active .hamburger-line:nth-child(2) {
  opacity: 0;
}

.menu-toggle.active .hamburger-line:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}

/* 移动端菜单 */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001; /* 提高层级，确保在固定导航栏之上 */
  pointer-events: none;
}

.mobile-menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.mobile-menu.open .mobile-menu-overlay {
  opacity: 1;
  pointer-events: all;
}

.mobile-menu-content {
  position: absolute;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100%;
  background: white;
  transition: right 0.3s ease;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.mobile-menu.open .mobile-menu-content {
  right: 0;
  pointer-events: all;
}

.mobile-nav-links {
  padding: 5rem 2rem 2rem;
}

.mobile-nav-link {
  display: block;
  padding: 1rem;
  color: #333;
  font-size: 1.2rem;
  font-weight: 500;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
}

.mobile-nav-link:hover,
.mobile-nav-link.active {
  background-color: #f8f9fa;
  color: #667eea;
}

.mobile-nav-link:active {
  background-color: #e9ecef;
  transform: scale(0.98);
  transition: all 0.1s ease;
}

/* 桌面端导航 */
.desktop-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
}

.nav-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 0.5rem;
  position: relative;
}

.logo-container {
  position: absolute;
  left: 0;
  margin-right: 1rem;
  flex-shrink: 0;
}

.company-logo {
  height: 100px;
  width: auto;
  object-fit: contain;
}

.company-name {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  text-align: center;
  flex-grow: 1;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: white;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  background-color: rgba(255, 255, 255, 0.2);
}

/* 主要内容 */
.main-content {
  flex: 1;
  padding: 580px 0 2rem 0; /* 为固定导航栏留出适当空间 */
  width: 100%;
}

/* 页脚 */
.site-footer {
  background: #2c3e50;
  color: white;
  margin-top: auto;
  width: 100%;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem 0;
}

.footer-section h3,
.footer-section h4 {
  margin-bottom: 1rem;
  color: #3498db;
}

.footer-section ul {
  list-style: none;
}

.footer-section li {
  margin-bottom: 0.5rem;
}

.footer-section a {
  color: #bdc3c7;
  transition: color 0.3s ease;
}

.footer-section a:hover {
  color: #3498db;
}

/* 联系方式链接样式 */
.contact-link {
  display: inline-block;
  text-decoration: none;
  transition: all 0.2s ease;
}

.phone-link {
  color: #bdc3c7;
  font-weight: 500;
}

.phone-link:hover {
  color: #3498db;
  transform: translateX(3px);
}

.email-link {
  color: #bdc3c7;
  font-weight: 500;
}

.email-link:hover {
  color: #3498db;
  transform: translateX(3px);
}

.phone-link:active,
.email-link:active {
  opacity: 0.8;
  transform: scale(0.98);
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding: 1rem 0;
  text-align: center;
  color: #bdc3c7;
}

.icp-info {
  margin-top: 0.5rem;
  font-size: 0.9rem;
}

.icp-link {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #3498db;
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .main-content {
    padding: 80px 0 1rem 0; /* 移动端为固定导航栏留出更多空间 */
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .mobile-header-content {
    padding: 0.75rem;
  }
  
  .logo h1 {
    font-size: 1.3rem;
  }
  
  .mobile-menu-content {
    width: 280px;
  }
  
  .mobile-nav-links {
    padding: 4rem 1.5rem 1.5rem;
  }
}
</style>